import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Legacy WordPress `/vuelos/` → current flights route. Kept as a permanent
 * redirect so the old URL never 404s.
 */
export const Route = createFileRoute("/vuelos")({
  beforeLoad: () => {
    throw redirect({ to: "/flights", statusCode: 301 });
  },
});
